import { render, staticRenderFns } from "./MySider.vue?vue&type=template&id=d381f49e&scoped=true&"
import script from "./MySider.vue?vue&type=script&lang=js&"
export * from "./MySider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d381f49e",
  null
  
)

export default component.exports